import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';
import { useTranslation } from 'react-i18next';
import ControlledCheckbox from '../../../../shared/ControlledFields/ControlledCheckbox';

const TravelCostContent = ({ control }) => {
  const { t } = useTranslation('common', { keyPrefix: 'costCenterSettings' });

  return (
    <MultiStepForm.Section title={t('postalCode.title')} fullPadding={false}>
      <ControlledCheckbox
        control={control}
        name="exclude-travelcost-calculation"
        label={t('postalCode.label')}
      />
    </MultiStepForm.Section>
  );
};

export default TravelCostContent;
